const config = {
    // DON'T USE process environment variable
    // because that variable might not available on Android.
    amexEnabled: false,
}

module.exports = config